import { ApplicationProfileEntityToDto } from "src/app/features/ApplicationProfile/services/mappers/ApplicationProfileEntityToDto";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { ApplicationProfileEntity } from "../../types/ApplicationProfileEntity";
import { ApplicationProfileApacEntityToDto } from "../mappers/ApplicationProfileApacEntityToDto";
import { ApplicationProfileDtoToEntity } from "../mappers/ApplicationProfileDtoToEntity";

const ApplicationProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        ApplicationProfileLoad: builder.query<ApplicationProfileEntity, FormQuery>({
            providesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return ApplicationProfileDtoToEntity(response);
            },
        }),
        ApplicationProfileApacSave: builder.mutation<ApplicationProfileEntity, FormMutation<ApplicationProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}`;
                const method = "POST";

                const body = ApplicationProfileApacEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
        }),
        ApplicationProfileApacUpdate: builder.mutation<ApplicationProfileEntity, FormMutation<ApplicationProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${mutation.data.id}`;
                const method = "PUT";

                const body = ApplicationProfileApacEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
        }),
        ApplicationProfileEft4fSave: builder.mutation<ApplicationProfileEntity, FormMutation<ApplicationProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}`;
                const method = "POST";

                const body = ApplicationProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
        }),
        ApplicationProfileEft4fUpdate: builder.mutation<ApplicationProfileEntity, FormMutation<ApplicationProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${mutation.data.id}`;
                const method = "PUT";

                const body = ApplicationProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
        }),
    }),
});

export const {
    useApplicationProfileLoadQuery,
    useApplicationProfileApacSaveMutation,
    useApplicationProfileApacUpdateMutation,
    useApplicationProfileEft4fSaveMutation,
    useApplicationProfileEft4fUpdateMutation,
} = ApplicationProfileApi;
